import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import SectionWrapper from '../../components/marketing/SectionWrapper';

export default function AccessibilityStatementPage() {
  const { t } = useTranslation();

  return (
    <>
      <section className="pt-24 pb-14 bg-gradient-to-br from-cyan-50/60 via-white to-teal-50/40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 tracking-tight">{t('footer.accessibility')}</h1>
          </motion.div>
        </div>
      </section>

      <SectionWrapper background="white">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="max-w-3xl mx-auto prose prose-gray prose-sm md:prose-base"
          dir="rtl"
        >
          <p className="text-gray-500 text-sm mb-6">עודכן לאחרונה: מרץ 2026</p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">1. מחויבותנו לנגישות</h2>
          <p className="text-gray-600 leading-relaxed">
            קיפיקיד בע"מ מחויבת להנגיש את אתר האינטרנט והמערכת שלה לאנשים עם מוגבלויות,
            בהתאם לתקן הישראלי SI 5568 ולהנחיות WCAG 2.1 ברמת AA.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">2. פעולות שננקטו</h2>
          <ul className="text-gray-600 leading-relaxed space-y-2 list-disc list-inside">
            <li>התאמת האתר לגלישה באמצעות מקלדת בלבד</li>
            <li>תמיכה בקוראי מסך ובטכנולוגיות מסייעות</li>
            <li>אפשרות שינוי גודל גופן ומרווחי שורות</li>
            <li>ניגודיות גבוהה ומצבי תצוגה מותאמים</li>
            <li>תיאורי טקסט חלופי לתמונות</li>
            <li>מבנה כותרות היררכי וסמנטי</li>
            <li>סמן גדול להקלה על ניווט</li>
          </ul>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">3. תפריט נגישות</h2>
          <p className="text-gray-600 leading-relaxed">
            באתר קיים תפריט נגישות המאפשר התאמה אישית של חוויית הגלישה. ניתן לגשת אליו באמצעות
            כפתור הנגישות הצף בפינת המסך.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">4. דפדפנים נתמכים</h2>
          <p className="text-gray-600 leading-relaxed">
            האתר מותאם לדפדפנים Chrome, Firefox, Safari ו-Edge בגרסאותיהם העדכניות.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">5. פנייה בנושא נגישות</h2>
          <p className="text-gray-600 leading-relaxed">
            אם נתקלתם בבעיית נגישות באתר, נשמח לשמוע ולטפל בהקדם.
            ניתן לפנות אלינו בדוא"ל: info@kipikid.com או בטלפון: 050-5774499.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">6. רכז נגישות</h2>
          <p className="text-gray-600 leading-relaxed">
            רכז הנגישות של קיפיקיד זמין לפניות בנושאי נגישות בכל אמצעי התקשורת המפורטים לעיל.
          </p>
        </motion.div>
      </SectionWrapper>
    </>
  );
}
